























import { Component, Vue, Prop } from 'vue-property-decorator'
import ButtonComponent from './ButtonComponent.vue'
@Component({
  components: {
    ButtonComponent
  }
})

export default class ButtonGroupComponent extends Vue {
  @Prop() public mainBtnText!: string;
  @Prop() public secondaryBtnText!: string;
  @Prop() public isLoading?: boolean
  @Prop() public sticky?: boolean;
  @Prop() public fullwidth?: boolean;
  @Prop() public inactive?: boolean;

  public mainBtnClick () {
    if (!this.isLoading) {
      this.$emit('mainBtnClick')
    }
  }

  public secondaryBtnClick () {
    this.$emit('secondaryBtnClick')
  }
}
